import { ITypedReduxAction } from '../../types/redux/actionType';
import { EFrequency, ISavedSearch } from '../../types/savedSearch';

export enum ESavedSearchActionTypes {
  Set = 'saved_searches/SET',
  Remove = 'saved_searches/search/REMOVE',
  ChangeFrequency = 'saved_searches/search/CHANGE_FREQUENCY',
  ChangeTitle = 'saved_searches/search/CHANGE_TITLE',
}

export interface ISetSavedSearchPayload {
  isFetching: boolean;
  errorCode?: number;
  count: number | null;
  searches: ISavedSearch[] | null;
}
export interface IRemoveSavedSearchPayload {
  ids: number[];
}

export interface IChangeFrequencySavedSearchPayload {
  frequency: EFrequency | null;
  id: number;
  status: string;
}

export interface IChangeTitleSavedSearchPayload {
  id: number;
  title: string;
}

export type TSavedSearchSet = ITypedReduxAction<ESavedSearchActionTypes.Set, ISetSavedSearchPayload>;
export type TSavedSearchRemove = ITypedReduxAction<ESavedSearchActionTypes.Remove, IRemoveSavedSearchPayload>;
export type TSavedSearchChangeFrequency = ITypedReduxAction<
  ESavedSearchActionTypes.ChangeFrequency,
  IChangeFrequencySavedSearchPayload
>;
export type TSavedSearchChangeTitle = ITypedReduxAction<
  ESavedSearchActionTypes.ChangeTitle,
  IChangeTitleSavedSearchPayload
>;

export type TSavedSearchActions =
  | TSavedSearchSet
  | TSavedSearchRemove
  | TSavedSearchChangeFrequency
  | TSavedSearchChangeTitle;
